import React, { useState, useEffect } from 'react'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Processing from '@modules/core/components/Loading'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import CoreV2 from '@services/CoreV2'
import AccessControl from '../../auth/AccessControl'
import InputField from '../../formFields/InputField'
import ReactPhoneInput from 'react-phone-input-2'
import DatePicker from 'react-datepicker'
import SelectField from '../../formFields/SelectField'
import InfoPanel from '@modules/admin/common/infoPanel'
import moment from 'moment'
import Select from 'react-select'
import _ from 'lodash'
import 'react-phone-input-2/lib/style.css'
import '../../formFields/DateTimeField.scss'
import { CustomerMigrationsBlock } from './CustomerMigrationsBlock'
import { email as validateEmail } from '../../formFields/services/validations'

export default function CustomerShowNew(props) {
  const [customer, setCustomer] = useState({})
  const [isFetching, setIsFetching] = useState(false)
  const [isEditMode, setEditMode] = useState(false)
  const [initialEditData, setInitialEditData] = useState({})
  const [userGroups, setUserGroups] = useState()
  const customerHash = props.match.params.hash
  const isProd = import.meta.env.VITE_REACT_APP_ENV === 'PRODUCTION'
  const url = isProd ? 'https://panel.meetingdoctors.com' : 'https://panel.staging.meetingdoctors.com'
  const verificationCodesLink = `${url}/main/customers/${customerHash}/verification-codes`
  const [editData, setEditData] = useState({
    name: '',
    email: '',
    manager_email: '',
    phone: '',
    phone_prefix: '',
    nid_number: '',
    birthdate: '',
    gender: '',
    status: '',
    userGroup: '',
    allow_paid_leaves: false,
  })
  const stateValues = [
    { id: 0, name: '0 - Freemium' },
    { id: 2, name: '2 - Activo' },
    { id: 3, name: '3 - Baja' },
  ]
  const { t } = useTranslation()
  const allowedPaidLeavesLabel = t('customers.allow_paid_leaves', { defaultValue: 'Permitir bajas retribuidas' })
  const managerEmailLabel = t('customers.manager_email', { defaultValue: 'Email del manager' })
  const yesLabel = t('general.yes', { defaultValue: 'Sí' })
  const noLabel = t('general.no', { defaultValue: 'No' })

  function getData() {
    getUserData()
  }

  const getUserData = async () => {
    setIsFetching(true)
    await Consultations.customer
      .show(customerHash)
      .then((response) => {
        setCustomer(response.data)
        setIsFetching(false)
        const {
          name,
          firstname,
          lastname,
          email,
          manager_email,
          mobile_phone,
          mobile_phone_prefix,
          nid_number,
          birthdate,
          gender,
          status,
          vip,
          allow_paid_leaves,
          company_group_id,
          company_id,
          consultation_migrated,
        } = response.data
        let customerEditValues = {
          name: name,
          firstname: firstname,
          lastname: lastname,
          email: email,
          manager_email: manager_email || '',
          phone: mobile_phone,
          phone_prefix: mobile_phone_prefix,
          nid_number: nid_number,
          birthdate: birthdate,
          gender: gender,
          status: status,
          vip: vip && vip === 1 ? true : false,
          allow_paid_leaves: !!allow_paid_leaves,
          company_group_id: company_group_id,
          consultationMigrated: consultation_migrated,
        }
        setEditData(customerEditValues)
        setInitialEditData(customerEditValues)
        return company_id
      })
      .then((company_id) => getCompanyGroupsData(company_id))
      .catch((err) => console.log(err))
  }

  const getCompanyGroupsData = async (company_id) => {
    let filters = { company_id: company_id }

    await Consultations.userGroups
      .indexUpdated({}, filters)
      .then((response) => {
        let formattedArray = response.data.map((e) => ({ value: e.id, label: `${e.name} (${e.code})` }))
        setUserGroups(formattedArray)
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fullPhone = (prefix, number) => {
    return `${prefix ? '+' + prefix : ''} ${number ? number : ''}`
  }
  const getgender = (gender) => {
    let result = 'Hombre'
    if (gender && gender === 1) result = 'Mujer'
    if (gender === null) result = 'No especificado'

    return result
  }

  const managerEmailError = validateEmail(editData.manager_email)

  function saveData() {
    if (managerEmailError) {
      alert(managerEmailError)
      return
    }

    const date = editData.birthdate !== null ? moment(editData.birthdate, 'DD/MM/YYYY') : null
    const dateReady = date !== null ? date.format('DD/MM/YYYY') : null

    if (!editData.gender) {
      editData.gender = 0
    }

    let data = {
      ...editData,
      birthdate: dateReady,
      manager_email: editData.manager_email?.trim() || null,
      vip: editData.vip ? 1 : 0,
      name: `${editData.firstname} ${editData.lastname}`,
    }

    setIsFetching(true)
    Consultations.customer
      .updateWithHash(customerHash, data)
      .then(() => {
        if (data.status === 3) {
          CoreV2.updateHeaders({ apiKey: customer.company_api_key })
          CoreV2.customers.unsubscribe(customer.token, { unsubscribed_at: moment().format('YYYY-MM-DD') })
        }
      })
      .then(() => {
        setIsFetching(false)
        setEditMode(false)
        getData()
      })
      .catch((err) => {
        setIsFetching(false)
        alert(err)
        console.log(err)
      })
  }

  const checkSaveButtonStatus = () => {
    if (!editData.gender) {
      editData.gender = 0
    }
    let result = _.isEqual(editData, initialEditData)

    /* const isEmpty = Object.values(editData).some((value) => {
      let result = false
      if (!value && value !== 0) {
        result = true
      }
      return result
    })
    result = isEmpty */

    return result || !!managerEmailError
  }

  const formatStatus = (type) => {
    if ((customer.status !== undefined) & !isEditMode) {
      let statusLabel = ''
      let classStatus = ''

      switch (customer.status) {
        case 0:
          statusLabel = 'Estado: Freemium (0)'
          classStatus = 'state-label state0'
          break
        case 2:
          statusLabel = 'Estado: Activo (2)'
          classStatus = 'state-label state2'
          break
        case 3:
          statusLabel = 'Estado: Baja (3)'
          classStatus = 'state-label state3'
          break
        default:
          statusLabel = 'Sin estado'
          classStatus = 'state-label'
          break
      }

      return type === 'value' ? statusLabel : classStatus
    }
  }

  return (
    <div className="crud-wrapper professional-wrapper">
      <div className="professional-show">
        <DashboardHeader title={customer.name ? customer.name : 'Anónimo'}>
          <button className="btn btn-primary" onClick={() => setEditMode(true)}>
            <Trans>Editar</Trans>
          </button>
          <Link className="btn btn-primary" to={`/customers`}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>

        <Processing isFetching={isFetching} />

        {customer !== null && (
          <div className="container-fluid main-content">
            <div className="form-crud well">
              <div className="title-section">
                <h1 className="title-label">
                  <Trans>Datos usuario</Trans>
                </h1>
                <div>
                  <div className="vip_input">
                    <input
                      type="checkbox"
                      id="vip"
                      name="vip"
                      checked={editData.vip}
                      disabled={!isEditMode ? 'disabled' : null}
                      onChange={(e) => setEditData({ ...editData, vip: e.target.checked })}
                    />
                    <label htmlFor="vip">{t('vipUser')}</label>
                  </div>
                  <span className={formatStatus('class')}>{formatStatus('value')}</span>
                </div>
              </div>
              <div className="block">
                <div className="block_row">
                  <div className="form-group grid-element ">
                    <label>{t('Nombre')}</label>
                    {isEditMode ? (
                      <InputField
                        placeholder={t('Nombre')}
                        input={{
                          value: editData.firstname ? editData.firstname : '',
                          onChange: (e) => setEditData({ ...editData, firstname: e.target.value }),
                        }}
                      />
                    ) : (
                      <span>{customer.firstname ? customer.firstname : 'Anónimo'}</span>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>{t('lastName')}</label>
                    {isEditMode ? (
                      <InputField
                        placeholder={t('lastName')}
                        input={{
                          value: editData.lastname ? editData.lastname : '',
                          onChange: (e) => setEditData({ ...editData, lastname: e.target.value }),
                        }}
                      />
                    ) : (
                      <span>{customer.lastname ? customer.lastname : 'Anónimo'}</span>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Email</Trans>
                    </label>
                    {!isEditMode ? (
                      <span>{customer.email}</span>
                    ) : (
                      <InputField
                        placeholder={t('Email')}
                        input={{
                          value: editData.email ? editData.email : '',
                          onChange: (e) => setEditData({ ...editData, email: e.target.value }),
                        }}
                        disabled={customer.token_type === 'email'}
                      />
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>{managerEmailLabel}</label>
                    {!isEditMode ? (
                      <span>{customer.manager_email || '-'}</span>
                    ) : (
                      <InputField
                        placeholder={managerEmailLabel}
                        input={{
                          value: editData.manager_email ? editData.manager_email : '',
                          onChange: (e) => setEditData({ ...editData, manager_email: e.target.value }),
                        }}
                        type="email"
                        meta={managerEmailError ? { touched: true, error: managerEmailError } : {}}
                      />
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>{allowedPaidLeavesLabel}</label>
                    {!isEditMode ? (
                      <span>{editData.allow_paid_leaves ? yesLabel : noLabel}</span>
                    ) : (
                      <div className="vip_input">
                        <input
                          type="checkbox"
                          id="allow_paid_leaves"
                          name="allow_paid_leaves"
                          checked={!!editData.allow_paid_leaves}
                          onChange={(e) => setEditData({ ...editData, allow_paid_leaves: e.target.checked })}
                        />
                        <label htmlFor="allow_paid_leaves">{allowedPaidLeavesLabel}</label>
                      </div>
                    )}
                  </div>

                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Teléfono</Trans>
                    </label>
                    {!isEditMode ? (
                      <span>{fullPhone(customer.mobile_phone_prefix, customer.mobile_phone)}</span>
                    ) : (
                      <div className="phone-box">
                        <ReactPhoneInput
                          value={
                            editData.phone_prefix && editData.phone
                              ? fullPhone(editData.phone_prefix, editData.phone)
                              : ''
                          }
                          defaultCountry="no"
                          onChange={(value, country) => {
                            setEditData({
                              ...editData,
                              phone: value.substring(2),
                              phone_prefix: country.dialCode,
                            })
                          }}
                          disabled={customer.token_type === 'phone'}
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>DNI</Trans>
                    </label>
                    {!isEditMode ? (
                      <span>{customer.nid_number}</span>
                    ) : (
                      <InputField
                        placeholder={t('DNI')}
                        input={{
                          value: editData.nid_number ? editData.nid_number : '',
                          onChange: (e) =>
                            setEditData({
                              ...editData,
                              nid_number: e.target.value,
                            }),
                        }}
                        disabled={customer.token_type === 'nid_number'}
                      />
                    )}
                  </div>

                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Fecha de nacimiento</Trans>
                    </label>

                    {!isEditMode ? (
                      <span>{customer.birthdate}</span>
                    ) : (
                      <div className="date-picker-calendar md-field">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={editData.birthdate ? moment(editData.birthdate, 'DD/MM/YYYY').toDate() : null}
                          wrapperClassName="date-picker-input"
                          onChange={(date) => {
                            if (date) {
                              setEditData({ ...editData, birthdate: moment(date).format('DD/MM/YYYY') })
                            } else {
                              setEditData({ ...editData, birthdate: null })
                            }
                          }}
                          locale="es"
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Género</Trans>
                    </label>

                    {!isEditMode ? (
                      <span>{getgender(editData.gender)}</span>
                    ) : (
                      <div className="date-picker-calendar md-field">
                        <SelectField
                          clearable={false}
                          input={{
                            value: editData.gender ? editData.gender : 0,
                            onChange: (value) => setEditData({ ...editData, gender: value.id }),
                          }}
                          options={[
                            { id: 0, name: t('Hombre') },
                            { id: 1, name: t('Mujer') },
                          ]}
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>País</Trans>
                    </label>
                    <span>{customer.country_code}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Idiomas</Trans>
                    </label>
                    <span>{customer.language_code}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Token</Trans>
                    </label>
                    <span>{customer.token}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Hash</Trans>
                    </label>
                    <span>{customer.hash}</span>
                  </div>
                </div>
              </div>

              <hr />

              <h1 className="title-label">
                <Trans>Datos compañía</Trans>
              </h1>
              <div className="block">
                <div className="block_row">
                  <AccessControl>
                    <div className="form-group grid-element ">
                      <label>
                        <Trans>Compañía</Trans>
                      </label>
                      <span>{customer.company_name}</span>
                    </div>
                    {customer?.company_group_name && (
                      <div className="form-group grid-element ">
                        <label>
                          <Trans>userGroup</Trans>
                        </label>
                        {editData.company_group_id && userGroups && isEditMode ? (
                          <Select
                            options={userGroups}
                            name="userGroup"
                            onChange={(e) => setEditData({ ...editData, company_group_id: e.value })}
                            defaultValue={userGroups?.find((e) => e.value === editData.company_group_id)}
                          />
                        ) : (
                          <span>{customer.company_group_name}</span>
                        )}
                      </div>
                    )}
                  </AccessControl>
                </div>
                <div className="block_row">
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Tipo de cuenta</Trans>
                    </label>
                    <span>{customer.coverage_name}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Número de póliza</Trans>
                    </label>
                    <span>{customer.contract_number}</span>
                  </div>
                </div>
              </div>

              <hr />

              <h1 className="title-label">
                {t('customers.verification-codes.block.title', {
                  defaultValue: 'Códigos de verificación',
                })}
              </h1>
              <div className="block">
                <InfoPanel
                  background="grey"
                  text={t('customers.verification-codes.disclaimer', {
                    defaultValue: 'Códigos de verificación',
                  })}
                  iconFont="fa-info-circle"
                  link={{
                    text: t('customers.verification-codes.text-link', {
                      defaultValue: 'Abrir link',
                    }),
                    url: verificationCodesLink,
                  }}
                />
              </div>
              <hr />

              <h1 className="title-label">
                <Trans>Actividad</Trans>
              </h1>
              <div className="block">
                <div className="block_row">
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Estado</Trans>
                    </label>
                    {!isEditMode ? (
                      <span>
                        {stateValues.map((value) => {
                          let result
                          if (value.id === customer.status) result = value.name
                          return result
                        })}
                      </span>
                    ) : (
                      <div className="date-picker-calendar md-field">
                        <SelectField
                          clearable={false}
                          input={{
                            value: editData.status ? editData.status : 0,
                            onChange: (value) => setEditData({ ...editData, status: value.id }),
                          }}
                          options={stateValues}
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Fecha de suscripción</Trans>
                    </label>
                    <span>{customer.subscribed_at}</span>
                  </div>
                </div>
                <div className="block_row">
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Fecha de cancelación de la suscripción</Trans>
                    </label>
                    <span>{customer.unsubscribed_at}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Fecha de sincronización</Trans>
                    </label>
                    <span>{customer.synchronized_at}</span>
                  </div>
                  <div className="form-group grid-element ">
                    <label>
                      <Trans>Fecha de desinstalación</Trans>
                    </label>
                    <span>{customer.uninstalled_at}</span>
                  </div>
                </div>
              </div>

              {!isFetching ? (
                <>
                  <hr />
                  <CustomerMigrationsBlock
                    markAsMigrated={(result) => {
                      setInitialEditData({
                        ...initialEditData,
                        consultationMigrated: !!result,
                      })
                    }}
                    consultationMigrated={initialEditData.consultationMigrated}
                    userHash={customerHash}
                  />
                </>
              ) : null}

              {isEditMode ? (
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault()
                      saveData()
                    }}
                    disabled={checkSaveButtonStatus()}
                  >
                    <Trans>Guardar</Trans>
                  </button>
                  <button className="btn btn-outline-primary left-button" onClick={() => setEditMode(false)}>
                    <Trans>Cancelar</Trans>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
